import removeConversationData from './helpers/removeConversationData';
import removeItemData from './helpers/removeItemData';
import { toggleSelectRow } from 'owa-mail-actions';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';

export default action('removeRowData')(function removeRowData(
    rowKey: string,
    tableView: TableView
) {
    // 1. If the row being removed is selected, remove item from selected item ids.
    // This should be done before we delete tableRowRelationKey as this sets
    // isSelected property on it.
    if (tableView.selectedRowKeys.has(rowKey)) {
        toggleSelectRow(
            tableView,
            rowKey,
            false /* isUserNavigation */,
            MailListItemSelectionSource.RowRemoval
        );
    }

    // 2. Remove the row data
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            removeConversationData(rowKey, tableView);
            break;

        case ReactListViewType.Message:
            removeItemData(rowKey, tableView);
            break;
    }
});
